export default __webpack_public_path__ + "72f16a684a3bc397cd0a26e65154adc4.svg";